import { render, staticRenderFns } from "./ImageOverlay.vue?vue&type=template&id=0a9d7dd3"
import script from "./ImageOverlay.vue?vue&type=script&lang=js"
export * from "./ImageOverlay.vue?vue&type=script&lang=js"
import style0 from "./ImageOverlay.vue?vue&type=style&index=0&id=0a9d7dd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports